module.exports = __webpack_public_path__ + "static/img/bottom.e559e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/bottom.png
// module id = 9zza
// module chunks = 4